{
  "name": "absg-nim-client-station",
  "version": "3.3.638",
  "angular-cli": {},
  "scripts": {
    "build": "yarn ng-high-memory build --base-href ./",
    "build:test": "yarn set-serve:test && yarn ng-high-memory build --base-href ./ --configuration=test",
    "build:stage": "yarn set-serve:stage && yarn ng-high-memory build --base-href ./ --configuration=stage",
    "build:stageweb": "yarn set-serve:stageweb && yarn ng-high-memory build --base-href ./ --configuration=stageweb",
    "ci": "yarn htmlvalidate && yarn lint && yarn tests-with-coverage && yarn build && yarn compile-e2e",
    "ci-local": "yarn htmlvalidate && yarn lint && yarn compile-e2e && yarn test:ci && yarn e2e -- --suite=smoke",
    "clean-e2e": "del-cli ./out-tsc-playwright-e2e",
    "compile-e2e": "yarn clean-e2e && tsc -p ./e2e-playwright/tsconfig.json",
    "copy-connect-assets": "node ./absg_node_scripts/copy-connect-assets",
    "electron": "node ./absg_node_scripts/electron --noAutoUpdate=yes",
    "electron:local": "node ./absg_node_scripts/electron --noAutoUpdate=yes --environment=local",
    "electron:dev": "node ./absg_node_scripts/electron --noAutoUpdate=yes --environment=dev",
    "electron:test": "node ./absg_node_scripts/electron --noAutoUpdate=yes --environment=test",
    "electron:stage": "node ./absg_node_scripts/electron --noAutoUpdate=yes --environment=stage",
    "electron:prod": "node ./absg_node_scripts/electron --noAutoUpdate=yes --environment=prod",
    "electron:mac": "node ./absg_node_scripts/electron --noAutoUpdate=yes --environment=dev --override=true",
    "htmlvalidate": "html-validate \"src/**/*.html\"",
    "lint": "yarn lint:hm",
    "lint-fix": "node --max_old_space_size=10000 ./absg_node_scripts/lint-fix",
    "lint:hm": "yarn ng-high-memory lint",
    "lint:fix": "node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng lint --fix",
    "ng-high-memory": "node --max_old_space_size=19000 ./node_modules/@angular/cli/bin/ng",
    "package": "node --max_old_space_size=10000 ./absg_node_scripts/package --environment=dev",
    "postinstall": "yarn copy-connect-assets && electron-builder install-app-deps",
    "serve": "yarn set-serve:original && yarn ng-high-memory serve",
    "serve:dev": "yarn set-serve:dev && yarn ng-high-memory serve --configuration=dev",
    "serve:test": "yarn set-serve:test && yarn ng-high-memory serve --configuration=test",
    "serve:stage": "yarn set-serve:stage && yarn ng-high-memory serve --configuration=stage",
    "serve:stageweb": "yarn set-serve:stageweb && yarn ng-high-memory serve --configuration=stageweb",
    "serve:noreload": "yarn ng-high-memory serve --watch=false",
    "set-serve:original": "node ./absg_node_scripts/set-serve-env.js --environment=original",
    "set-serve:dev": "node ./absg_node_scripts/set-serve-env.js --environment=dev",
    "set-serve:test": "node ./absg_node_scripts/set-serve-env.js --environment=test",
    "set-serve:stage": "node ./absg_node_scripts/set-serve-env.js --environment=stage",
    "set-serve:stageweb": "node ./absg_node_scripts/set-serve-env.js --environment=stageweb",
    "setEnvironment": "node ./absg_node_scripts/load-environment",
    "start:slow": "yarn start:local",
    "start:dev-auto-update": "concurrently --raw --kill-others --success first \"yarn serve\" \"yarn electron -- --environment=dev --noAutoUpdate=yes\"",
    "start:dev": "concurrently --raw --kill-others --success first \"yarn serve\" \"yarn electron -- --environment=dev\"",
    "start:local": "concurrently --raw --kill-others --success first \"yarn serve\" \"yarn electron -- --environment=local\"",
    "start:test": "concurrently --raw --kill-others --success first \"yarn serve\" \"yarn electron -- --environment=test\"",
    "start:mac": "concurrently --raw --kill-others --success first \"yarn serve\" \"yarn electron -- --environment=dev --override=true\"",
    "test": "yarn ng-high-memory test --code-coverage false --watch=true",
    "test:ci": "yarn ng-high-memory test --name",
    "tests-with-coverage": "node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng test --watch=false --code-coverage --browsers ChromeHeadless",
    "vsts-auth": "./node_modules/.bin/vsts-npm-auth -config .npmrc",
    "playwright:install": "npx playwright install --with-deps chromium",
    "playwright:trace": "npx playwright show-trace trace.zip",
    "control-flow": "yarn ng-high-memory g @angular/core:control-flow"
  },
  "private": true,
  "dependencies": {
    "@absg/angular-common": "9.0.4",
    "@absg/angular-components": "34.1.0",
    "@absg/angular-platform": "40.0.0",
    "@absg/api-emr-integration": "6.0.19",
    "@absg/api-entitlements": "14.1.8",
    "@absg/api-formulary": "12.3.3",
    "@absg/api-identity": "8.0.5",
    "@absg/api-inventory": "15.2.4",
    "@absg/api-lookup": "10.0.1",
    "@absg/api-party": "15.2.81",
    "@absg/api-patient": "13.0.1",
    "@absg/api-pricing": "2.0.0",
    "@absg/api-printing": "5.0.0",
    "@absg/api-purchase-order": "12.0.2",
    "@absg/api-station-management": "17.0.16",
    "@absg/e2e-api": "0.3.11",
    "@absg/nim-client-shared": "20.0.17",
    "@azure/msal-angular": "4.0.16",
    "@azure/msal-browser": "4.16.0",
    "@electron/remote": "2.1.2",
    "@microsoft/applicationinsights-web": "3.3.10",
    "absg-nim-native-node": "6.1.8",
    "angular-calendar": "0.31.1",
    "angular-google-tag-manager": "1.5.1",
    "angular-imask": "6.6.3",
    "angular2-hotkeys": "16.0.1",
    "applicationinsights": "1.8.10",
    "autoprefixer": "6.6.1",
    "bindings": "1.2.1",
    "can-use-webview": "1.0.3",
    "core-js": "3.43.0",
    "cuid": "3.0.0",
    "decimal.js": "10.5.0",
    "lodash-es": "4.17.21",
    "luxon": "3.7.2",
    "ngx-pagination": "6.0.3",
    "odata-query": "6.7.1",
    "rxjs": "7.8.2",
    "subsink": "1.0.2",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.15",
    "@angular/animations": "19.2.14",
    "@angular/cdk": "19.2.19",
    "@angular/cli": "19.2.15",
    "@angular/common": "19.2.14",
    "@angular/compiler": "19.2.14",
    "@angular/compiler-cli": "19.2.14",
    "@angular/core": "19.2.14",
    "@angular/forms": "19.2.14",
    "@angular/material": "19.2.19",
    "@angular/platform-browser": "19.2.14",
    "@angular/platform-browser-dynamic": "19.2.14",
    "@angular/router": "19.2.14",
    "@bwip-js/browser": "4.7.0",
    "@paralleldrive/cuid2": "2.2.2",
    "@playwright/test": "~1.54.0",
    "@types/jasmine": "3.3.11",
    "@types/lodash-es": "4.17.12",
    "@types/node": "18.16.9",
    "angular-eslint": "20.4.0",
    "bcryptjs": "2.4.3",
    "concurrently": "7.2.2",
    "cp-connect-style": "2.23.86",
    "cpr": "3.0.1",
    "del-cli": "5.0.0",
    "electron": "36.7.0",
    "electron-builder": "24.6.4",
    "electron-ipc-mock": "0.0.3",
    "electron-rebuild": "3.2.9",
    "electron-reload": "2.0.0-alpha.1",
    "eslint": "9.37.0",
    "fs-extra": "11.3.0",
    "guid-typescript": "1.0.9",
    "html-validate": "7.3.0",
    "intl": "1.2.5",
    "jasmine-core": "3.6.0",
    "jasmine-spec-reporter": "5.0.2",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.1.1",
    "karma-cli": "2.0.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "4.0.1",
    "karma-jasmine-html-reporter": "1.7.0",
    "karma-junit-reporter": "1.2.0",
    "karma-parallel": "0.3.1",
    "karma-spec-reporter": "0.0.34",
    "minimist": "1.2.8",
    "ng-bullet": "1.0.3",
    "portfinder": "1.0.32",
    "ts-node": "10.9.2",
    "tslib": "2.8.1",
    "typescript": "5.5.4",
    "typescript-eslint": "8.46.2",
    "yargs": "17.5.1"
  },
  "false": {}
}